import React from 'react';
import PropTypes from 'prop-types';

/**
 * Wrapper around setTimeout
 */
class Timeout extends React.Component {
  state = {id: null, fired: false};

  componentDidMount() {
    const { delay } = this.props;
    const id = setTimeout(this.handleTimeout, delay);
    this.setState((state) => ({...state, id}));
  }

  componentWillUnmount() {
    clearTimeout(this.state.id);
  }

  render() {
    const { before, after } = this.props;
    const { fired } = this.state;
    return fired ? after : before;
  }

  handleTimeout = () => {
    clearTimeout(this.state.id);
    this.setState((state) => ({...state, id: null, fired: true}));
  };
}

export default Timeout;

Timeout.propTypes = {
  before: PropTypes.node.isRequired,
  after: PropTypes.node.isRequired,
};
